import React from 'react';

import svgIcon from 'components/hoc/svgIcon';

const svg = (
  <svg width="5" height="10" viewBox="0 0 5 10">
    <path d="M.6 8.7c-.166.22-.12.534.1.7.22.166.534.12.7-.1l3-4c.133-.178.133-.422 0-.6l-3-4C1.234.48.92.434.7.6c-.22.166-.266.48-.1.7L3.375 5 .6 8.7z" />
  </svg>
);

export default svgIcon(svg);
